import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Resolve,Router, RouterStateSnapshot } from '@angular/router';
import { UserService,User } from '../../shared';


@Component({
  templateUrl: 'support.component.html',
  styleUrls: ['./style.component.css']
  
  
})

export class SupportComponent implements OnInit {
  public data: Object;
  CurrentUser:User;
  constructor(
    
    private router: Router,
    private route: ActivatedRoute,
    private userService:UserService
    
  ) {
    
  }


  
  
  ngOnInit() {
    
    //////console.log(this.route.snapshot.url);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if(this.route.snapshot.url[0].path != 'assessment'){
			this.CurrentUser.operationStatus = ''
		  }
   
  }
  
   
}
  

   
 
  

